let JudgeData = null;

const walkJudgeData = (questionList, config) => {
  questionList.forEach((item) => {
    const logicQuesTypeId = parseInt(item.logicQuesTypeId, 10);
    const { childList } = item;
    if (logicQuesTypeId === 9 && Array.isArray(childList) && childList.length > 0) {
      walkJudgeData(childList, config);
    } else if (logicQuesTypeId !== 9) {
      // eslint-disable-next-line no-undef
      const stuAnswer = TalqsInteraction.getData(item.queId)
      JudgeData[item.queId] = {
        queId: item.queId,
        gradeGroupId: parseInt(item.gradeGroupId, 10),
        rigAnswer: item.normalAnswer || item.answer,
        blankAnswer: item.blankAnswer,
        type: logicQuesTypeId,
        subjectId: parseInt(item.subjectId, 10),
        stuAnswer: stuAnswer&&stuAnswer[0].data,
      };
      config.halfRight && (JudgeData[item.queId].halfRight = true);
      config.content && (JudgeData[item.queId].content = item.content);
    }
  });
};

const combinedAnswer = answerData => answerData.map(answer => JudgeData[answer.queId].stuAnswer = answer.data);


const convertData = data => Object.values(data);

/**
 * 获取判题数据
 * @param {object} question 试题数据
 * @param {array} answerData 答题数据
 */
const getJudgeData = (question, answerData, config = {}) => {
  JudgeData = {};
  walkJudgeData([question], config);
  if(answerData) {
    combinedAnswer(Array.isArray(answerData) ? answerData : [answerData]);
  }
  return convertData(JudgeData);
};

export default getJudgeData;
